import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-home-page-global-talent',
  template: `
    <fl-section-homepage-feature
      [srcImageAnimationMobile]="'home/global-talent/global-talent-cards-m.png'"
      [srcImageAnimationTablet]="'home/global-talent/global-talent-cards-t.png'"
      [srcImageAnimationLargeDesktop]="
        'home/global-talent/global-talent-cards-ld.png'
      "
      [srcBackgroundMobile]="'home/global-talent/global-talent-bg-m.png'"
      [srcBackgroundTablet]="'home/global-talent/global-talent-bg-ld.jpg'"
      [srcBackgroundLargeDesktop]="'home/global-talent/global-talent-bg-ld.jpg'"
    >
      <fl-section-homepage-feature-title i18n="Section title">
        Tap into a
        <p class="text-primary text-size-inherit font-weight-inherit">
          global talent network
        </p>
      </fl-section-homepage-feature-title>
      <fl-section-homepage-feature-top-left>
        <fl-section-homepage-entry>
          <fl-section-homepage-entry-heading i18n="Section heading">
            Post your job
          </fl-section-homepage-entry-heading>
          <fl-section-homepage-entry-description i18n="Section description">
            It's free and easy! Get lots of competitive bids that suit your
            budget in minutes. Start making your dreams reality.
          </fl-section-homepage-entry-description>
        </fl-section-homepage-entry>
      </fl-section-homepage-feature-top-left>
      <fl-section-homepage-feature-top-right>
        <fl-section-homepage-entry>
          <fl-section-homepage-entry-heading i18n="Section heading">
            Choose freelancers
          </fl-section-homepage-entry-heading>
          <fl-section-homepage-entry-description i18n="Section description">
            No job is too big or complex. We've got freelancers for jobs of any
            size or budget, across 2700+ skills. Let our talent bring your ideas
            to life.
          </fl-section-homepage-entry-description>
        </fl-section-homepage-entry>
      </fl-section-homepage-feature-top-right>
      <fl-section-homepage-feature-bottom-left>
        <fl-section-homepage-entry>
          <fl-section-homepage-entry-heading i18n="Section heading">
            Pay safely
          </fl-section-homepage-entry-heading>
          <fl-section-homepage-entry-description i18n="Section description">
            Only pay for work when you are 100% satisfied with the outcome. Our
            milestone payment system protects you every step of the way.
          </fl-section-homepage-entry-description>
        </fl-section-homepage-entry>
      </fl-section-homepage-feature-bottom-left>
      <fl-section-homepage-feature-bottom-right>
        <fl-section-homepage-entry>
          <fl-section-homepage-entry-heading i18n="Section heading">
            We're here to help
          </fl-section-homepage-entry-heading>
          <fl-section-homepage-entry-description i18n="Section description">
            Your time is precious. Let our team of expert recruiters and
            co-pilots save you time finding talent, even managing your job if
            needed.
          </fl-section-homepage-entry-description>
        </fl-section-homepage-entry>
      </fl-section-homepage-feature-bottom-right>
      <fl-section-homepage-feature-footer
        i18n-footerCopy="Footer description"
        i18n-footerLink="Footer link"
        footerCopy="Create the future."
        footerLink="Get started now"
        [footerUrl]="'/post-project'"
      >
      </fl-section-homepage-feature-footer>
    </fl-section-homepage-feature>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageGlobalTalentComponent {}
